/**
 * Contructor
 */
const config = {};

/**
 * Development configurations
 */
config.development = {
  kambria: 'https://localhost:3000',
  bounty: 'https://localhost:3000',
  codebase: 'https://localhost:3000',
  store: 'https://localhost:3000',
  token: 'https://localhost:5000',
};

/**
 * Staging configurations
 */
config.staging = {
  kambria: 'https://staging-app.kambria.io',
  bounty: 'https://staging-bounty.kambria.io',
  codebase: 'https://staging-codebase.kambria.io',
  store: 'https://staging-store.kambria.io',
  token: 'https://staging-token.kambria.io',
};

/**
 * Production configurations
 */
config.production = {
  kambria: 'https://app.kambria.io',
  bounty: 'https://bounty.kambria.io',
  codebase: 'https://codebase.kambria.io',
  store: 'https://store.kambria.io',
  token: 'https://token.kambria.io',
};

/**
 * Module exports
 */
export default config;